
<template>
    <div class="one-hundred-percent">
        <template v-if="url">
            <div :id="playerId" class="one-hundred-percent"></div>
        </template>
        <template v-else>
            <img v-if="resource && (resource.convertStatus === Constants.ResourceConvertStatus.Waiting || resource.convertStatus === Constants.ResourceConvertStatus.Transcoding)" :src="require('@/web-framework/assets/images/transcoding.gif')" class="one-hundred-percent" />
            <img v-else-if="resource && resource.convertStatus === Constants.ResourceConvertStatus.Faild" :src="require('@/web-framework/assets/images/transcodingFailed.png')" class="one-hundred-percent" />
            <div v-else-if="resource && resource.auditStatus != Constants.Code.AUDIT_APPROVED" style="position: absolute;left: 45%;top: 50%;">资源文件尚未通过审核</div>
            <div v-else-if="resource && resource.convertStatus === Constants.ResourceConvertStatus.Success && resource.auditStatus == Constants.Code.AUDIT_APPROVED" :id="playerId" class="one-hundred-percent"></div>
        </template>
    </div>
</template>

<script>
import ResourceAPI from "@/web-framework/api/resources.js";
import SettingsAPI from "@/web-framework/api/settings.js";
export default {
    components: {
    },
    props: {
        urlSuffix: {                    // url 后缀
            type: String,
            default: ''
        },
        url: {                          // 全路径url
            type: String,
            default: ''
        },
        resourceId: {
            type: String,
            default: ''
        },
        forceLook: {                    // 是否强制观看，不允许拖动
            type: Boolean,
            default: true
        },
        writeProgress: {                // 是否记录进度
            type: Boolean,
            default: true
        },
        autoPlay: {                     // 是否自动播放
            type: Boolean,
            default: false
        },
        intervalToWriteProgress: {      // 记录进度时间间隔
            type: Number,
            default: 20
        },
        cmpId: {                        // 组件Id，存在多个播放器时需要传递此项，避免重复
            type: String,
            default: "yushuCKPlayer"
        },
        onReady: {
            type: Function,
            default: () => {
                return;
            }
        },
        onPlaying: {
            type: Function,
            default: () => {
                return;
            }
        }
    },
    watch: {
        urlSuffix: {
            async handler(val) {
                if (val) {
                    this.init(null, null, this.urlSuffix, this.url);
                }
            },
            immediate: true,
        },
        url: {
            async handler(val) {
                if (val) {
                    this.init(null, null, null, this.url);
                }
            },
            immediate: true,
        },
        resourceId: {
            async handler(val) {
                if (val) {
                    this.init(null, null, null, null, this.resourceId);
                }
            },
            immediate: true,
        }
    },
    data() {
        return {
            playerId: this.Utils.uuid(),                    // 播放器id
            player: null,                                   // 播放器
            handler: '',                            // 间隔函数句柄
            chapter: {},                                    // 章节
            resource: {},                                   // 资源
            videoClockins: [],                              // 视频打点问题
            chapterVideoProgress: {},                       // 当前视频学习进度
            watermarker: null,                              // 水印图片
            watermarkSize: null,                            // 水印尺寸
            playerParams: {                                 // 播放参数
                container: "#video-show",                   // 容器的ID或className
                variable: "player",                         // 播放函数名称
                loaded: this.cmpId,                         // 组件Id
                autoplay: false,                            // 是否自动播放
                html5m3u8: true,                            // 是否启用html5m3u8支持
                debug: false,                               // 不启用调试模式
                playbackRate: false,                        // 播放状态
                timeJump: 10,                                // 快进快退时的秒数
            },
            videoObject: this.playerParams,                 // 当前播放对象
            duration: 0,                                    // 视频时长
            currentQuestion: {
            },
            finishedClock: [],
            dlgDataVideoClock: {
                visible: false
            }
        };
    },
    beforeDestroy() {
        this.destory();
    },
    mounted() {
        if (this.onReady) {
            this.onReady();
        }
    },
    methods: {
        async init(chapter, resource, urlSuffix, fullUrl, resourceId) {
            let transcodeSetting = await SettingsAPI.getSetting(this.Constants.Settings.TRANSCODE_SETTING);
            if (transcodeSetting && transcodeSetting.success && transcodeSetting.data && transcodeSetting.data.value && transcodeSetting.data.value.length > 0) {
                transcodeSetting = transcodeSetting.data;
                let service = transcodeSetting.value == this.Constants.Code.TRANSCODE_TYPE_YUSHU ? 'transcode' : 'upload';
                let provider = transcodeSetting.value == this.Constants.Code.TRANSCODE_TYPE_YUSHU ? 'transcodeConfig' : 'aliyunTranscodeConfig';
                let configResult = await Request.get(`/${service}/${provider}`);
                if (configResult && configResult.success && configResult.data && !configResult.data.enableCompoundWatermark) {
                    if (configResult.data && configResult.data.watermark) {
                        this.watermarker = configResult.data.watermark;
                        Vue.set(this, 'watermarker', configResult.data.watermark);
                    }
                    if (configResult.data && configResult.data.watermarkSize) {
                        this.watermarkSize = "200x40";
                        Vue.set(this, 'watermarkSize', "200x40");
                    }
                }
            }

            if (chapter) {
                Vue.set(this, 'chapter', chapter);

                // 加载视频打点信息
                let result = await ChapterAPI.findChapterClockin({ courseId: chapter.courseId, chapterId: chapter.id });
                Vue.set(this, 'videoClockins', result.data);

                result = await StudentAPI.getStudentChapterVideoProgress(chapter.courseId, chapter.id);
                Vue.set(this, 'chapterVideoProgress', result.data);
            }

            // 加载进度数据
            if (!resource && chapter) {
                this.loadResource(chapter.fileId);
            } else if (resource) {
                Vue.set(this, 'resource', resource);

                setTimeout(() => {
                    this.initPlayer();
                }, 500);
            } else if (!resource && !chapter && urlSuffix && urlSuffix.length > 0) {
                this.loadResource(urlSuffix);
            } else if (this.Utils.isNull(chapter) && this.Utils.isNull(resource) && this.Utils.isNull(urlSuffix) && fullUrl && fullUrl.length > 0) {
                this.initPlayerForUrl(this.url);
            } else if (this.Utils.isNull(chapter) && this.Utils.isNull(resource) && this.Utils.isNull(urlSuffix) && resourceId && resourceId.length > 0) {
                this.loadResource(resourceId);
            }
        },
        // 初始化播放器
        initPlayer() {
            // 检查当前资源是否可用
            if (!this.isValidResource())
                return;

            this.videoObject = !this.videoObject ? this.playerParams : this.videoObject;
            this.videoObject.container = "#" + this.playerId;
            if (this.watermarker) {
                let logo = '<img src="' + this.Utils.getResourceUrl(this.watermarker) + '" ';
                if (this.watermarkSize) {
                    let p = this.watermarkSize.split('x');
                    logo = logo + ' style="width : ' + p[0] + 'px;height:' + p[1] + 'px"'
                }
                logo = logo + " >";
                this.videoObject.logo = logo;
            }

            // 初始化播放器配置
            this.initPlayerParamsConfig();
            this.attachPlayerEvent();
        },
        initPlayerForUrl(url) {
            this.videoObject = !this.videoObject ? this.playerParams : this.videoObject;
            this.videoObject.container = "#" + this.playerId;
            this.videoObject.video = url;

            setTimeout(() => {
                Vue.set(this, 'player', new ckplayer(this.videoObject));
                this.attachPlayerEvent();
            }, 500);
        },
        attachPlayerEvent() {
            window[this.cmpId] = () => {
                // 播放器加载后会调用该函数
                this.player.addListener("play", () => {
                    // 监听播放的函数
                    this.onVideoStart();
                });
                this.player.addListener("time", (seconds) => {
                    // 监听播放进度，如果存在视频打点，在播放到相应的位置时弹出答题对话框
                    let intTime = parseInt(seconds);
                    if (this.onPlaying) {
                        this.onPlaying(intTime);
                    }
                    if (this.isInPopQuestion(intTime)) {
                        this.player.videoPause();
                        this.showQuestionDialog(intTime);
                    }
                });
                this.player.addListener("pause", () => {
                    // 代理视频停止播放事件
                    this.onVideoPause();
                });
                this.player.addListener("ended", () => {
                    // 代理视频播放完成事件
                    this.onVideoEnd();
                });
                this.player.addListener("duration", (seconds) => {
                    // 代理视频准备完成事件
                    this.onVideoReady(seconds);
                });
                // 设置是否可拖动
                this.allowDrive(!this.forceLook);
            };
        },
        // 视频转呗完成触发
        onVideoReady(duration) {
            this.duration = duration;
        },
        // 音频播放
        onVideoStart() {
            if (this.handler) {
                window.clearInterval(this.handler);
                this.handler = null;
            }

            if (!this.writeProgress)
                return;

            if (this.Utils.isNull(this.chapterVideoProgress) || this.Utils.isNull(this.chapterVideoProgress.percent)) {
                this.$emit('onPlayStart', 0, 0);
            }

            this.handler = window.setInterval(() => {
                this.onVideoProgress();
            }, this.intervalToWriteProgress * 1000);
        },
        // 音频播放中，跟踪播放进度
        onVideoProgress() {
            if (!this.writeProgress)
                return;

            try {
                let currentTime = parseInt(this.player.time);
                let percent = currentTime / this.duration * 100;

                // if (this.Utils.isNull(this.chapterVideoProgress) || this.Utils.isNull(this.chapterVideoProgress.percent) || this.chapterVideoProgress.percent < percent)
                this.$emit('onPlayProgress', currentTime, percent);
            } catch (exception) {
            }
        },
        // 音频暂停
        onVideoPause() {
            if (this.handler) {
                window.clearInterval(this.handler);
                this.handler = null;
            }

            if (!this.writeProgress)
                return;
            try {
                let currentTime = parseInt(this.player.time);
                let percent = currentTime / this.duration * 100;

                if (this.Utils.isNull(this.chapterVideoProgress) || this.Utils.isNull(this.chapterVideoProgress.percent) || this.chapterVideoProgress.percent < percent)
                    this.$emit('onPlayPause', currentTime, percent);
            } catch (exception) {
            }
        },
        // 音频播放完毕
        onVideoEnd() {
            if (this.handler) {
                window.clearInterval(this.handler);
                this.handler = null;
            }

            if (!this.writeProgress)
                return;

            // if (this.Utils.isNull(this.chapterVideoProgress) || this.Utils.isNull(this.chapterVideoProgress.percent) || this.chapterVideoProgress.percent < 100)
            this.$emit('onPlayFinished', parseInt(this.duration), 100)

        },
        // 判断当前资源是否有效
        isValidResource() {
            return (this.resource.convertStatus === this.Constants.ResourceConvertStatus.Success && this.resource.auditStatus == this.Constants.Code.AUDIT_APPROVED);
        },
        // 初始化视频参数
        async initPlayerParamsConfig() {
            let aliyunDefinitions = ['FD', 'LD', 'HD', 'SD'];
            let aliyunDefinitionNames = ['流畅', '标清', '高清', '超清'];
            let yushuDefinitions = ['SD', 'HD', 'LD', 'FD'];
            let yushuDefinitionNames = ['超清', '高清', '标清', '流畅'];

            if (this.resource.transcodeFilesInfo) {
                let videos = JSON.parse(this.resource.transcodeFilesInfo);
                this.videoObject.video = [];
                for (let i = 0; i < videos.length; i++) {
                    let item = videos[i];

                    let num = 0;
                    if (item.definition && aliyunDefinitions.indexOf(item.definition) != -1) {
                        // 阿里云转换结果
                        num = aliyunDefinitions.indexOf(item.definition);
                        if (num == -1)
                            num = 0;
                        if (!item.label) {
                            item.label = aliyunDefinitionNames[aliyunDefinitions.indexOf(item.definition)];
                        }
                    } else if (item.resolutionType && yushuDefinitions.indexOf(item.resolutionType) != -1) {
                        num = yushuDefinitions.indexOf(item.resolutionType);
                        if (!item.label) {
                            item.label = yushuDefinitionNames[yushuDefinitions.indexOf(item.resolutionType)]
                        }
                    }

                    let playUrl = item.url ? item.url : item.playURL;
                    if (!playUrl.startsWith('http') && playUrl.indexOf('/') == -1) {
                        let resourceResult = await ResourceAPI.getResourceInfoByUnique(playUrl);
                        if (resourceResult.success && resourceResult.data && resourceResult.data.url && resourceResult.data.url.length > 0) {
                            playUrl = this.Utils.getResourceUrl(resourceResult.data.url);
                        }
                    }
                    this.videoObject.video.push([playUrl, `video/${item.format}`, item.label, num]);
                }
            }

            let posterUrl = this.resource.posterUrl;
            if (posterUrl && posterUrl.length > 0 && !posterUrl.startsWith("http") && posterUrl.indexOf('/') == -1) {
                // 尝试转换
                let posterResult = await ResourceAPI.getResourceInfoByUnique(posterUrl);
                if (posterResult.success && posterResult.data && posterResult.data.url && posterResult.data.url.length > 0) {
                    posterUrl = this.Utils.getResourceUrl(posterResult.data.url);
                }
            }
            if (posterUrl && posterUrl.length > 0) {
                this.videoObject.poster = posterUrl;
            }

            this.videoObject["seek"] = this.chapterVideoProgress.percent === 100 ? 0 : this.chapterVideoProgress.playTime;
            Vue.set(this, 'player', new ckplayer(this.videoObject))
        },
        isInPopQuestion(time) {
            // 检查当前时间是否在弹题中
            if (!this.videoClockins || this.videoClockins.length == 0) {
                return false;
            }
            let timePointLabel = this.Utils.formatSecondsDurationToLabel(time);
            let found = this.Utils.filterArray(this.videoClockins, 'timePoint', timePointLabel);

            if (!found || found.length == 0)
                return false;

            if (found[0] == this.currentQuestion) {
                return false;
            }
            return true;
        },
        showQuestionDialog(time) {
            if (!this.videoClockins || this.videoClockins.length == 0) {
                return false;
            }

            let timePointLabel = this.Utils.formatSecondsDurationToLabel(time);
            let found = this.Utils.filterArray(this.videoClockins, 'timePoint', timePointLabel);

            let question = found[0].question;
            this.dlgDataVideoClock.questionId = question.id;
            this.currentQuestion = found[0];
            this.modalShow();
        },
        modalShow() {
            this.dlgDataVideoClock.visible = true;
        },
        closePopQuestion() {
            this.dlgDataVideoClock.visible = false;
        },
        playOrPause() {
            if (this.player) {
                this.player.playOrPause();
            }
        },
        videoPause() {
            if (this.player) {
                this.player.videoPause();
            }
        },
        fastNext: function (s) {
            // 快进
            this.player.ckplayerConfig["config"]["timeJump"] = s;
            this.player.fastNext();
        },
        fastBack: function (s) {
            // 快退
            this.player.ckplayerConfig["config"]["timeJump"] = s;
            this.player.fastBack();
        },
        videoSeek: function (number) {
            // 跳转的时间（秒）
            this.player.videoSeek(number);
        },
        // 设置是否可拖动
        allowDrive: function (bAllowDrive) {
            this.player.ckplayerConfig["config"]["timeScheduleAdjust"] = bAllowDrive ? 1 : 0;
            if (bAllowDrive) {
                this.player.ckplayerConfig["config"]["keyDown"] = {
                    space: true,//是否启用空格键切换播放/暂停
                    left: true,//是否启用左方向键快退
                    right: true,//是否启用右方向键快进
                    up: true,//是否支持上方向键增加音量
                    down: true //是否支持下方向键减少音量
                }
            } else {
                this.player.ckplayerConfig["config"]["keyDown"] = {
                    space: true,//是否启用空格键切换播放/暂停
                    left: false,//是否启用左方向键快退
                    right: false,//是否启用右方向键快进
                    up: true,//是否支持上方向键增加音量
                    down: true //是否支持下方向键减少音量
                }
            }
        },
        afterAnswer(isRight) {
            if (isRight) {
                this.player.videoPlay();
            }
        },
        // 加载资源
        loadResource(fileId) {
            ResourceAPI.getResourceInfoByUnique(fileId).then(result => {
                Request.validateResult(result, () => {
                    Vue.set(this, 'resource', result.data);
                    setTimeout(() => {
                        this.initPlayer();
                    }, 500);
                });
            });
        },
        destory() {
            try {
                Vue.set(this, 'resource', null);
                Vue.set(this, 'videoClockins', []);
                Vue.set(this, 'chapterVideoProgress', null);
                Vue.set(this, 'player', null);
            } catch (exception) {
            }
        }
    }
};
</script>
<style lang="less">
.one-hundred-percent {
    height: 100%;
    width: 100%;
    position: relative;
}
</style>
<style lang="less" scoped>
.questiono-header {
    margin-bottom: 20px;
}

.questiono-main {
    padding-left: 40px;

    .question-item {
        line-height: 50px;
        height: 50px;
    }

    .common_test_option {
        line-height: 50px;
        height: 50px;
    }
}
</style>